'use client'

import { useState } from 'react'

import { useConversationContext } from '@marketplace-web/domain/core-conversation'
import { EnsureBalanceActivated } from '@marketplace-web/domain/balance-activation'
import {
  ConversationActionButton,
  ConversationActionProps,
} from '@marketplace-web/domain/conversation-action'

import WeHaveMetConfirmationModal from '../WeHaveMetConfirmationModal'

const WeHaveMet = (props: ConversationActionProps) => {
  const { conversation } = useConversationContext()

  const transactionId = conversation?.transaction?.id

  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false)

  const handleConfirmationOpen = () => setIsConfirmationOpen(true)

  const handleConfirmationClose = () => setIsConfirmationOpen(false)

  const { primary, title, inverse, theme, size } = props

  if (!transactionId) return null

  return (
    <>
      <EnsureBalanceActivated {...props} onSuccess={handleConfirmationOpen}>
        <ConversationActionButton
          text={title}
          primary={primary}
          size={size}
          theme={theme}
          inverse={inverse}
          onClick={handleConfirmationOpen}
        />
      </EnsureBalanceActivated>
      <WeHaveMetConfirmationModal
        isOpen={isConfirmationOpen}
        onClose={handleConfirmationClose}
        transactionId={transactionId}
      />
    </>
  )
}

export default WeHaveMet
